// /search — Phase 08 unified hybrid search page. Mounted under _admin so
// auth + org gates fire before render. q + types are URL-synced for F5
// resilience and shareable links.
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import UnifiedSearchPage from "@/features/search/components/unified-search-page";

const searchSchema = z.object({
  q: z.string().optional().catch(undefined),
  // Comma-separated subset of: knowledge, kg_entity, media, folder.
  types: z.string().optional().catch(undefined),
});

export const Route = createFileRoute("/_admin/search")({
  validateSearch: searchSchema.parse,
  component: UnifiedSearchPage,
});
